angular.
module("dx.webapp.lists", [
	"digiexam.components",
	"digiexam.exam",
	"digiexam.gradingMatrix",
	"digiexam.services",
	"digiexam.services.faults",
	"dx.webapp.api",
	"dx.webapp.navigation",
	"dx.webapp.exams",
	"dx.webapp.session",

	"dx.ui.components.dialog",
	"dx.ui.components.localize",
	"dx.ui.components.scroll",
]);
